import { lazy } from 'react';

const ReportList = lazy(() =>
  import('../../components/pages/ReportList/ReportList'),
);
const ReportsPZ05 = lazy(() =>
  import('../../components/pages/ReportsPZ05/ReportsPZ05'),
);
const AddReportPZ05 = lazy(() =>
  import('../../components/pages/AddReportPZ05/AddReportPZ05'),
);
const EditReportPZ05 = lazy(() =>
  import('../../components/pages/EditReportPZ05/EditReportPZ05'),
);
const DetailsPZ05 = lazy(() =>
  import('../../components/pages/DetailsPZ05/DetailsPZ05'),
);

export const pz05Routes = [
  {
    path: '/pz05',
    permission: 'pz05.list',
    access: 'authenticated',
    roles: [
      'ADMIN',
      'KONTROLER',
      'KIER_DS_REKLAMACJI',
      'DSM',
      'KIER_ODC_BWH',
      'KIER_SYST_ZAPEWNIENIA_JAK',
      'LIDER_PRZEPAKOWANIA',
      'ROZLEW',
      'WOM',
    ],
    Component: ReportList,
  },
  {
    path: '/pz05/raport',
    permission: 'pz05.export',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER', 'KIER_DS_REKLAMACJI'],
    Component: ReportsPZ05,
  },
  {
    path: '/add-pz05',
    permission: 'pz05.create',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: AddReportPZ05,
  },
  {
    path: '/edit-pz05/:id',
    permission: 'pz05.edit',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: EditReportPZ05,
  },
  {
    path: '/details-pz05/:id',
    permission: 'pz05.view',
    access: 'authenticated',
    roles: [
      'ADMIN',
      'KONTROLER',
      'KIER_DS_REKLAMACJI',
      'KIER_SYST_ZAPEWNIENIA_JAK',
      'KIER_ODC_BWH',
      'LIDER_PRZEPAKOWANIA',
      'WOM',
      'DSM',
    ],
    Component: DetailsPZ05,
  },
];
